(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airvex-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('[data-axtp]').forEach(function (s) {
        if (s.dataset.ready) return;
        s.dataset.ready = '1';
        var dots = s.querySelectorAll('[data-axtp-dot]');
        var panels = s.querySelectorAll('[data-axtp-panel]');
        function show(i) {
          dots.forEach(function (d) { var on = d.getAttribute('data-axtp-dot') === String(i); d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-axtp-panel') !== String(i); });
        }
        dots.forEach(function (d) { d.addEventListener('click', function () { show(d.getAttribute('data-axtp-dot')); }); });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var d = e.target && e.target.closest && e.target.closest('[data-axtp-dot]');
      if (d) d.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-rooms-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ax-rooms-gallery')) {
    class AxRoomsGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.axr__track');
        const section = this.closest('.axr');
        this.prev = section?.querySelector('[data-axr-prev]');
        this.next = section?.querySelector('[data-axr-next]');
        if (!this.track) return;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.onPrev = () => this.step(-1);
        this.onNext = () => this.step(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.ro?.disconnect();
      }

      step(dir) {
        const card = this.track.querySelector('.axr__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: smooth ? 'smooth' : 'auto' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(scrollWidth - clientWidth, 0);
        const visible = scrollWidth ? clientWidth / scrollWidth : 1;
        const progress = max ? visible + (1 - visible) * (scrollLeft / max) : 1;
        this.style.setProperty('--axr-progress', `${Math.min(progress, 1) * 100}%`);
        if (this.prev) this.prev.disabled = scrollLeft <= 2;
        if (this.next) this.next.disabled = scrollLeft >= max - 2;
      }
    }
    customElements.define('ax-rooms-gallery', AxRoomsGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-buybar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Gemeinsame Kauf-Hilfe für Kaufleiste und Kaufimpuls */
    window.axBuy = window.axBuy || (function () {
      function form() {
        var all = document.querySelectorAll('product-form-component');
        return all.length ? all[0] : null;
      }
      function mainButton() {
        var f = form();
        return f ? f.querySelector('button[type="submit"]') : null;
      }
      function variantId() {
        var f = form();
        var i = f && f.querySelector('input[name="id"]');
        return i ? i.value : null;
      }
      function add(fallbackId) {
        /* Set-Angebot auf der Seite (AIRVEX · Set-Angebot): Set statt nur Gerät */
        if (window.axBundle && window.axBundle.active) { window.axBundle.add(); return true; }
        var b = mainButton();
        if (b && !b.disabled) { b.click(); return true; }
        var id = variantId() || fallbackId;
        if (!id) return false;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function () { window.location.href = root + 'cart'; });
        return true;
      }
      return { form: form, mainButton: mainButton, variantId: variantId, add: add };
    })();

    function init(root) {
      var bar = (root.querySelector ? root : document).querySelector('[data-axbar]');
      if (!bar || bar.dataset.ready) return;
      bar.dataset.ready = '1';

      var variants = [];
      try { variants = JSON.parse(bar.querySelector('[data-axbar-variants]').textContent); } catch (e) {}
      var priceEl = bar.querySelector('[data-axbar-price]');
      var varEl = bar.querySelector('[data-axbar-variant]');
      var imgEl = bar.querySelector('[data-axbar-img]');
      var btn = bar.querySelector('[data-axbar-add]');
      var label = bar.querySelector('[data-axbar-label]');
      var addText = label ? label.textContent : '';
      var soldText = bar.dataset.soldout || 'Ausverkauft';
      var single = variants.length === 1;
      var lastId = null;

      function sync() {
        var id = window.axBuy.variantId() || bar.dataset.fallbackVariant;
        if (!id || String(id) === lastId) return;
        lastId = String(id);
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        var bundleNote = window.axBundle && window.axBundle.active ? window.axBundle.note : '';
        if (varEl) varEl.textContent = bundleNote ? bundleNote + ' · ' : (single ? '' : v.title + ' · ');
        if (imgEl && v.image) imgEl.src = v.image;
        if (btn) btn.disabled = !v.available;
        if (label) label.textContent = v.available ? addText : soldText;
      }

      var visible = false;
      function setVisible(on) {
        if (on === visible) return;
        visible = on;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.body.classList.toggle('axbar-on', on && window.matchMedia('(max-width: 749px)').matches);
        if (on) sync();
      }

      if (bar.hasAttribute('data-preview')) { setVisible(true); }

      var target = document.querySelector('[data-axbundle-btn]') || window.axBuy.mainButton() || window.axBuy.form();
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (bar.hasAttribute('data-preview')) return;
            /* nur zeigen, wenn der Button nach oben aus dem Bild gescrollt ist */
            var above = e.boundingClientRect.top < 0;
            setVisible(!e.isIntersecting && above);
          });
        }, { threshold: 0 }).observe(target);
      }

      document.addEventListener('variant:update', function () { lastId = null; setTimeout(sync, 50); });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('variant-picker, product-form-component, fieldset')) {
          lastId = null;
          setTimeout(sync, 120);
        }
      });
      setInterval(function () { if (visible) sync(); }, 800);

      if (btn) btn.addEventListener('click', function () { window.axBuy.add(bar.dataset.fallbackVariant); });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.axBuy = window.axBuy || (function () {
      function form() {
        var all = document.querySelectorAll('product-form-component');
        return all.length ? all[0] : null;
      }
      function mainButton() {
        var f = form();
        return f ? f.querySelector('button[type="submit"]') : null;
      }
      function variantId() {
        var f = form();
        var i = f && f.querySelector('input[name="id"]');
        return i ? i.value : null;
      }
      function add(fallbackId) {
        var b = mainButton();
        if (b && !b.disabled) { b.click(); return true; }
        var id = variantId() || fallbackId;
        if (!id) return false;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function () { window.location.href = root + 'cart'; });
        return true;
      }
      return { form: form, mainButton: mainButton, variantId: variantId, add: add };
    })();

    function init(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('[data-axcta]').forEach(function (el) {
        if (el.dataset.ready) return;
        el.dataset.ready = '1';
        el.querySelectorAll('[data-axcta-add]').forEach(function (b) {
          b.addEventListener('click', function () { window.axBuy.add(el.dataset.fallbackVariant); });
        });
        /* Preis an die oben gewählte Variante anpassen (Preis aus dem Kaufbereich übernehmen) */
        var priceEl = el.querySelector('[data-axcta-price]');
        if (priceEl && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              var src = document.querySelector('product-price [ref="priceContainer"] .price, .product-details .price, product-price .price');
              if (src && src.textContent.trim()) priceEl.textContent = src.textContent.trim();
            });
          }).observe(el);
        }
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-axd]').forEach(function (el) {
        if (el.dataset.axdReady) return;
        el.dataset.axdReady = '1';
        var pins = el.querySelectorAll('[data-axd-pin]');
        var items = el.querySelectorAll('[data-axd-item]');
        var cur = el.querySelector('[data-axd-current]');
        var n = items.length;
        if (!n) return;
        var active = 0;

        function show(i) {
          active = (i + n) % n;
          pins.forEach(function (p, k) { p.classList.toggle('is-active', k === active); p.setAttribute('aria-pressed', k === active ? 'true' : 'false'); });
          items.forEach(function (it, k) { it.classList.toggle('is-active', k === active); });
          if (cur) cur.textContent = active + 1;
        }

        pins.forEach(function (p) {
          p.addEventListener('click', function () { show(parseInt(p.dataset.axdPin, 10)); });
        });
        el.querySelectorAll('[data-axd-select]').forEach(function (b) {
          b.addEventListener('click', function () { show(parseInt(b.dataset.axdSelect, 10)); });
          b.addEventListener('mouseenter', function () {
            if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches) show(parseInt(b.dataset.axdSelect, 10));
          });
        });
        var prev = el.querySelector('[data-axd-prev]');
        var next = el.querySelector('[data-axd-next]');
        if (prev) prev.addEventListener('click', function () { show(active - 1); });
        if (next) next.addEventListener('click', function () { show(active + 1); });

        /* Wischen auf dem Bild (mobil) */
        var stage = el.querySelector('.axd__stage');
        var x0 = null;
        if (stage) {
          stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            if (x0 === null) return;
            var dx = e.changedTouches[0].clientX - x0;
            if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1));
            x0 = null;
          }, { passive: true });
        }

        el.addEventListener('axd:select', function (e) { show(e.detail); });
        show(0);
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest && e.target.closest('[data-axd-item]');
      var sec = item && item.closest('[data-axd]');
      if (sec) sec.dispatchEvent(new CustomEvent('axd:select', { detail: parseInt(item.dataset.axdItem, 10) }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-howto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-axh]').forEach(function (el) {
        if (el.dataset.axhReady) return;
        el.dataset.axhReady = '1';
        var tabs = el.querySelectorAll('[data-axh-tab]');
        if (!tabs.length) return;
        var panels = el.querySelectorAll('[data-axh-panel]');
        var shots = el.querySelectorAll('[data-axh-shot]');
        var current = 0;
        var timer = null;
        var interval = 5000;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.style.setProperty('--axh-interval', interval / 1000 + 's');

        function show(i) {
          current = i;
          tabs.forEach(function (t, n) {
            var on = n === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var bar = t.querySelector('.axh__tab-bar');
            if (bar && on) { bar.style.animation = 'none'; bar.offsetWidth; bar.style.animation = ''; }
          });
          panels.forEach(function (p, n) { p.hidden = n !== i; p.classList.toggle('is-active', n === i); });
          shots.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        }
        function stop() { clearInterval(timer); timer = null; el.classList.remove('is-auto'); }
        function start() {
          if (reduce || window.Shopify && Shopify.designMode || tabs.length < 2) return;
          stop();
          el.classList.add('is-auto');
          timer = setInterval(function () { show((current + 1) % tabs.length); }, interval);
        }

        tabs.forEach(function (t) {
          t.addEventListener('click', function () { stop(); show(parseInt(t.dataset.axhTab, 10)); });
          t.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            stop();
            var n = (current + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            show(n);
            tabs[n].focus();
          });
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting && !el.dataset.axhTouched) start(); else stop();
            });
          }, { threshold: 0.35 }).observe(el.querySelector('.axh__app') || el);
        }
        el.addEventListener('click', function (e) { if (e.target.closest('[data-axh-tab]')) el.dataset.axhTouched = '1'; });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.closest && e.target.closest('[data-axh-tab]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-levels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(n, d) { return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); }
    function init(root) {
      root.querySelectorAll('[data-axl]').forEach(function (el) {
        if (el.dataset.axlReady) return;
        el.dataset.axlReady = '1';
        var vol = parseFloat(el.dataset.volume) || 120;
        var big = el.querySelector('[data-axl-big]');
        var detail = el.querySelector('[data-axl-detail]');
        var desc = el.querySelector('[data-axl-desc]');
        var meter = el.querySelector('[data-axl-meter]');
        if (!big) return;

        function update() {
          var lv = el.querySelector('.axl__levels input:checked') || el.querySelector('.axl__levels input');
          var hr = el.querySelector('.axl__hours input:checked') || el.querySelector('.axl__hours input');
          if (!lv || !hr) return;
          var rate = parseFloat(String(lv.value).replace(',', '.'));
          var hours = parseFloat(hr.value);
          if (!rate || !hours) return;
          var days = vol / (rate * hours);
          var main, unit;
          if (days >= 365) { main = 'über 1'; unit = 'Jahr'; }
          else if (days >= 60) { var m = Math.round(days / 30.4 * 2) / 2; main = 'ca. ' + fmt(m, m % 1 ? 1 : 0); unit = m === 1 ? 'Monat' : 'Monate'; }
          else if (days >= 14) { var w = Math.round(days / 7); main = 'ca. ' + w; unit = 'Wochen'; }
          else { var dd = Math.max(1, Math.round(days)); main = 'ca. ' + dd; unit = dd === 1 ? 'Tag' : 'Tage'; }
          big.innerHTML = main + ' <small>' + unit + '</small>';
          detail.textContent = '≈ ' + Math.round(days) + ' Tage · Verbrauch ca. ' + fmt(rate, 2) + ' ml pro Stunde';
          if (desc) desc.textContent = 'Stufe ' + (lv.dataset.name || '') + (lv.dataset.desc ? ' – ' + lv.dataset.desc : '');
          if (meter) meter.style.width = Math.min(100, days / 180 * 100) + '%';
        }
        el.addEventListener('change', update);
        update();
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-specs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-axs2]').forEach(function (el) {
        var btn = el.querySelector('[data-axs2-toggle]');
        if (!btn || btn.dataset.bound) return;
        btn.dataset.bound = '1';
        var more = btn.querySelector('[data-axs2-label-more]');
        var less = btn.querySelector('[data-axs2-label-less]');
        btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-collapsed') === false;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (more) more.hidden = open;
          if (less) less.hidden = !open;
          if (!open) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scent-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.axv').forEach(function (el) {
        var video = el.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');
        var btn = el.querySelector('[data-axv-toggle]');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function sync() {
          if (!btn) return;
          btn.classList.toggle('is-paused', video.paused);
          btn.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Video pausieren');
        }

        if (reduce) {
          video.pause();
        } else if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (btn && btn.dataset.userPaused === '1') return;
              if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
              else { video.pause(); }
            });
          }, { threshold: 0.25 }).observe(video);
        }

        if (btn && !btn.dataset.bound) {
          btn.dataset.bound = '1';
          btn.addEventListener('click', function () {
            if (video.paused) { btn.dataset.userPaused = '0'; video.play(); }
            else { btn.dataset.userPaused = '1'; video.pause(); }
          });
          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          sync();
        }
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["airvex-scroll-fade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ax-scroll-fade')) {
    class AxScrollFade extends HTMLElement {
      connectedCallback() {
        this.layers = [...this.querySelectorAll('[data-axsf-layer]')];
        this.dots = [...this.querySelectorAll('[data-axsf-dot]')];
        this.texts = [...this.querySelectorAll('.axsf__step .axsf__text')];
        this.active = 0;
        this.head = this.querySelector('[data-axsf-head]');
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const vh = Math.min(window.innerHeight, 1200);
        let next = 0;

        this.texts.forEach((el, i) => {
          const top = el.getBoundingClientRect().top;
          // Bild wechselt, sobald der Text von unten ins Bild kommt
          if (top < vh * 0.88) next = i;
          // Text löst sich auf, wenn er nach oben über das Produkt wandert
          const fade = (top - vh * 0.1) / (vh * 0.25);
          el.style.opacity = Math.max(0, Math.min(1, fade)).toFixed(3);
        });

        if (next !== this.active) {
          this.layers[this.active]?.classList.remove('is-active');
          this.dots[this.active]?.classList.remove('is-active');
          this.layers[next]?.classList.add('is-active');
          this.dots[next]?.classList.add('is-active');
          this.active = next;
        }

        if (this.head) {
          // Farbe der Kopfzeile folgt dem aktiven Bild (Textfarbe des Blocks)
          const light = this.layers[this.active]?.classList.contains('axsf__layer--light');
          this.head.classList.toggle('axsf__head--light', !!light);
          this.head.classList.toggle('axsf__head--dark', !light);
          if (this.head.dataset.mode === 'first') {
            this.head.classList.toggle('is-hidden', this.active > 0);
          }
        }
      }
    }
    customElements.define('ax-scroll-fade', AxScrollFade);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-moments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vrv) return;
    window.__vrv = true;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('vrv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    function scan() { document.querySelectorAll('[data-vrv]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-mood"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vrv) return;
    window.__vrv = true;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('vrv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    function scan() { document.querySelectorAll('[data-vrv]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-overview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-vov]').forEach(function (root) {
        if (root.dataset.vovReady) return;
        root.dataset.vovReady = '1';

        var chips = Array.prototype.slice.call(root.querySelectorAll('[data-vov-chip]'));
        var list = root.querySelector('[data-vov-list]');
        if (!list || !chips.length) return;
        var items = Array.prototype.slice.call(list.querySelectorAll('[data-vov-item]'));
        var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vov-panel]'));
        var countEl = root.querySelector('[data-vov-count]');
        var labelEl = root.querySelector('[data-vov-count-label]');
        var sortEl = root.querySelector('[data-vov-sort]');
        var slugs = chips.map(function (c) { return c.dataset.vovChip; });

        function apply(slug, updateHash) {
          if (slugs.indexOf(slug) === -1) slug = 'all';
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.vovChip === slug ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.dataset.vovPanel !== slug; });
          var shown = 0;
          items.forEach(function (li) {
            var on = slug === 'all' || li.dataset.family === slug;
            li.hidden = !on;
            li.classList.remove('is-in');
            if (on) {
              li.style.setProperty('--vov-d', Math.min(shown, 8) * 45 + 'ms');
              void li.offsetWidth;
              li.classList.add('is-in');
              shown++;
            }
          });
          if (countEl) countEl.textContent = shown;
          if (labelEl) labelEl.textContent = shown === 1 ? 'Duft' : 'Düfte';
          if (updateHash && window.history && history.replaceState) {
            var url = location.pathname + location.search + (slug === 'all' ? '' : '#' + slug);
            history.replaceState(null, '', url);
          }
        }

        function sortBy(mode) {
          var key = mode === 'warm' ? 'w' : mode === 'intense' ? 'i' : null;
          var sorted = items.slice().sort(function (a, b) {
            if (key) {
              var d = Number(a.dataset[key]) - Number(b.dataset[key]);
              if (d !== 0) return d;
            }
            return Number(a.dataset.num) - Number(b.dataset.num);
          });
          sorted.forEach(function (li) { list.appendChild(li); });
        }

        chips.forEach(function (c) {
          c.addEventListener('click', function () { apply(c.dataset.vovChip, true); });
        });
        if (sortEl) sortEl.addEventListener('change', function () { sortBy(sortEl.value); });

        var start = decodeURIComponent((location.hash || '').replace('#', ''));
        if (start && slugs.indexOf(start) !== -1) apply(start, false);

        window.addEventListener('hashchange', function () {
          var h = decodeURIComponent((location.hash || '').replace('#', ''));
          if (slugs.indexOf(h) !== -1) apply(h, false);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-profile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vrv) return;
    window.__vrv = true;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('vrv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    function scan() { document.querySelectorAll('[data-vrv]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vrv) return;
    window.__vrv = true;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('vrv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    function scan() { document.querySelectorAll('[data-vrv]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velun-ways"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vrv) return;
    window.__vrv = true;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('vrv-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    function scan() { document.querySelectorAll('[data-vrv]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
